<template>
  <b-card title="Doughnut">
    <b-card img-bottom>
      <ChartDoughnutBase :chart-data="chartData" />
    </b-card>
  </b-card>
</template>

<script>
import ChartDoughnutBase from "./ChartDoughnutBase.js";

export default {
  components: {
    ChartDoughnutBase
  },
  props:{
    right : {
       type: Number,
      required: true,
    },
    notAttempt : {
      type: Number,
      required: true,
    },
    wrong : {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      chartData: null
    };
  },
  mounted() {
    console.log("this.right",this.right)
    this.fillData();
  },
  methods: {
    fillData() {
      this.chartData = {
        datasets: [
          {
            backgroundColor: ["blueviolet","teal", "#ffdb3b" ],
            hoverBackgroundColor: ["#d1e3f7","#fbd2cd", "#fef5c9"],
            data: [this.right, this.notAttempt, this.wrong]
          }
        ],
        labels: ["Correct("+this.right+")", "No Attempt("+this.notAttempt+")", "Wrong("+this.wrong+")"]
      };
    }
  }
};
</script>
